import { motion } from "framer-motion";
import { Brain, Mic, Shield, Zap } from "lucide-react";
import { useTranslation } from "react-i18next";

export const FeaturesSection: React.FC = () => {
  // const { t } = useTranslation();
  
    const {t, i18n} = useTranslation();

  const features = [
    {
      icon: Brain,
      title: t('features.list.ai.title'),
      description: t('features.list.ai.description'),
      color: 'from-purple-500 to-blue-500'
    },
    {
      icon: Mic,
      title: t('features.list.voice.title'),
      description: t('features.list.voice.description'),
      color: 'from-pink-500 to-red-500'
    },
    {
      icon: Shield,
      title: t('features.list.security.title'),
      description: t('features.list.security.description'),
      color: 'from-green-500 to-teal-500'
    },
    {
      icon: Zap,
      title: t('features.list.speed.title'),
      description: t('features.list.speed.description'),
      color: 'from-yellow-500 to-orange-500'
    }
  ];

  return (
    <section id="features" className="py-20 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            {t('features.title')}
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            {t('features.subtitle')}
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
              className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all"
            >
              <div className={`w-16 h-16 bg-gradient-to-r ${feature.color} rounded-2xl flex items-center justify-center mb-6`}>
                <feature.icon className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};